import { CircularProgress, Dialog } from '@mui/material';
import React from 'react';
// import PropTypes from 'prop-types';

function CircularLoading(props) {
  const { loaderState } = props;
  return (
    <Dialog
      open={loaderState}
      BackdropProps={{
        style: {
          backgroundColor: "transparent"
        }
      }}
      PaperProps={{
        style: {
          backgroundColor: "transparent",
          boxShadow: "none",
          overflow: "hidden"
        },
      }}>
      <CircularProgress disableShrink color="primary" />
    </Dialog>
  )
}

// CircularLoading.propTypes = {
//   loaderState: PropTypes.bool.isRequired
// }

export default CircularLoading;